import moment from "jalali-moment";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { BsCalendar2Week, BsClockHistory } from "react-icons/bs";
import { GrLocation } from "react-icons/gr";
import { Link, useParams } from "react-router-dom";
import { apiService } from "../../base/service/service";
import config from "../../base/utils/config";
import set_day_name from "../../base/utils/set_day_name";
import { MdAttachMoney } from "react-icons/md";
import moneyFormat from "../../base/utils/moneyFormat";

export default function ConcertDetail() {
  const { concertToken } = useParams();
  const [concert, setConcert] = useState(null);
  const [prices, setPrices] = useState(null);
  useEffect(() => {
    getConcerts();
  }, []);
  function getConcerts() {
    apiService({ url: `api/events/event/${concertToken}` }).then((data) => {
      if (data && data.success === 1) {
        setConcert(data.data);
        let newPrices = [];
        data.row_prices?.map((price, p) => {
          let selectedRow = newPrices.find(
            (item) => item.price === price.price
          );
          if (selectedRow) {
            if (selectedRow?.extra_row_numbers) {
              selectedRow.extra_row_numbers = [
                ...selectedRow?.extra_row_numbers,
                price.row_number,
              ];
            } else {
              selectedRow.extra_row_numbers = [price.row_number];
            }
          } else {
            newPrices.push(price);
          }
        });
        setPrices(newPrices);
      }
    });
  }
  return (
    <div className="container-fluid px-0">
      {concert ? (
        <div className="row mx-0 mt-2">
          <div className="row mx-0 px-2">
            <div
              className="col-12 col-sm-6 px-0 mx-auto position-relative"
              style={{ minHeight: "180px" }}
            >
              <img className="w-100 rounded10" alt="" src={concert.banner} />
              <div
                className="position-absolute start-0 end-0 bottom-0 top-50 px-3 pb-3 row mx-0 rounded10"
                style={{
                  backgroundImage:
                    "linear-gradient(to top, #0000006b, #ffffff00)",
                }}
              >
                <p className="mb-0 text-white fs-7 fw-bolder col-12 px-0 align-self-end">
                  {concert.title}
                </p>
              </div>
            </div>
          </div>
          <div className="row mx-0 p-1">
            {concert.dates?.map((scene, s) => (
              <div className="col-12 col-sm-6 col-md-4 p-1">
                <Link
                  to={
                    scene.status === "active" &&
                    `/buy-ticket/${concert.id}/${scene.id}`
                  }
                >
                  <div className="row mx-0 px-0 rounded10">
                    <div className="col-auto p-2 bg-dark rounded-right-10 text-white text-center">
                      <p className="mb-0 space-pre">
                        {set_day_name(
                          moment(scene.start_time, "YYYY-MM-DD HH:mm:ss").day()
                        )}
                      </p>
                      <p className="mb-0 space-pre">
                        {moment(scene.start_time, "YYYY-MM-DD HH:mm:ss").format(
                          `jMM/jDD`
                        )}
                      </p>
                      <p className="mb-0 space-pre">
                        {moment(scene.start_time, "YYYY-MM-DD HH:mm:ss").format(
                          `HH:mm`
                        )}
                      </p>
                    </div>
                    <div className="col p-0 border border-2 border-dark rounded-left-10">
                      <div className="row mx-0 p-2 h-100">
                        <div className="col align-self-center p-0">
                          <p className="fs-7 mb-0 d-inline-block">
                            وضعیت:{" "}
                            {scene.status === "active" ? (
                              <span className="text-green fw-bolder">
                                موجود است
                              </span>
                            ) : scene.status === "disable" ? (
                              <span className="text-dark fw-bolder">
                                به زودی
                              </span>
                            ) : scene.status === "sold_out" ? (
                              <span className="text-red fw-bolder">
                                فروخته شد
                              </span>
                            ) : (
                              <span className="text-red fw-bolder">
                                اتمام یافت
                              </span>
                            )}
                          </p>
                        </div>
                        <div className="col-auto align-self-center p-0">
                          <button
                            disabled={scene.status !== "active"}
                            className="btn bg-dark text-white rounded7 fs-8 fw-bolder"
                          >
                            خرید بلیط
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
          <div className="px-2">
            <div className="row mx-0 px-0 bg-light-gray mt-2 rounded10 mb-3">
              <div className="col-12 px-0">
                <div className="row mx-0 px-2 py-3 border-bottom border-2 border-white">
                  <div className="col-auto align-self-center px-2">
                    <BsCalendar2Week className="my-auto h-100" />
                  </div>
                  <div className="col-auto px-2 align-self-center">
                    <p className="mb-0 fs-7 fw-bolder">دوره اجرا:</p>
                  </div>
                  <div className="col-auto px-2 align-self-center">
                    <p className="mb-0 fs-7 space-pre">
                      {set_day_name(
                        moment(
                          concert.dates[0]?.start_time,
                          "YYYY-MM-DD HH:mm:ss"
                        ).day()
                      )}
                      {"  "}
                      {moment(
                        concert.dates[0]?.start_time,
                        "YYYY-MM-DD HH:mm:ss"
                      ).format(`jMM/jDD`)}
                    </p>
                  </div>
                </div>
                <div className="row mx-0 px-2 py-3 border-bottom border-2 border-white">
                  <div className="col-auto align-self-center px-2">
                    <BsClockHistory className="my-auto h-100" />
                  </div>
                  <div className="col-auto px-2 align-self-center">
                    <p className="mb-0 fs-7 fw-bolder">ساعت:</p>
                  </div>
                  <div className="col-auto px-2 align-self-center">
                    <p className="mb-0 fs-7">
                      {concert.dates?.map(
                        (scene, s) =>
                          s < 2 && (
                            <span>
                              {s !== 0 && " و "}
                              {moment(
                                scene.start_time,
                                "YYYY-MM-DD HH:mm:ss"
                              ).format(`HH:mm`)}
                            </span>
                          )
                      )}
                    </p>
                  </div>
                </div>
                <div className="row mx-0 px-2 py-2 border-bottom border-2 border-white">
                  <div className="col-auto px-2 align-self-center">
                    <GrLocation className="my-auto h-100 ms-2" />
                    <span className="mb-0 fs-7 fw-bolder ms-2">
                      محل برگزاری:
                    </span>
                    <span className="mb-0 fs-7">
                      {concert.venue.short_address}
                    </span>
                  </div>
                  <div className="col-12 mt-2 px-2 align-self-center">
                    <span className="mb-0 fs-7">{concert.venue.address}</span>{" "}
                    <span className="mb-0 fs-7 me-1">
                      تلفن:{" "}
                      <a href={`tel:${concert?.phone}`}>{concert?.phone}</a>
                    </span>
                  </div>
                  {/* <div className="col-12 mt-3 px-2 align-self-center text-center"> */}
                  {/* <a
                      href={
                        window.Android
                          ? window.Android.openPaymentLink(
                              `http://maps.google.com/maps?q=${concert.latitude},${concert.longitude}`
                            )
                          : `http://maps.google.com/maps?q=${concert.latitude},${concert.longitude}`
                      }
                      className="p-0"
                      target="_blank"
                      rel="noreferrer"
                    > */}
                  {/* <img
                      className="rounded10 mw-100"
                      alt=""
                      src="https://www.google.com/maps/vt/data=21KhrPYGc-6fGRdCBBse0DC5809kNm9DbLlhwK62m5MG9APL_YJQ3ld6qW06TrA8r9_bIgFP0j4sgP9p76ZTfNYV_sp4rYl9tcA0NPLE1tke9uBKKuFJFC17kUoOJhSDRgIOGrgS9DRIXklZyPIJ2txkqKxiD9DhQOA"
                    /> */}
                  {/* </a> */}
                  {/* </div> */}
                </div>
                <div className="row mx-0 px-2 py-3 border-bottom border-2 border-white">
                  {prices?.map((price, p) => (
                    <div key={p} className="col-12 px-2 align-self-center mb-2">
                      <div className="row mx-0">
                        <div className="d-inline-block col-auto px-0">
                          <MdAttachMoney className="my-auto h-100 ms-2" />
                          <span className="mb-0 fs-7 ms-2 d-inline-block">
                            <span className="d-inline-block">
                              {price.floor_name} ردیف {price.row_number}
                            </span>
                            {price.extra_row_numbers?.map(
                              (extra_number, xn) => (
                                <span className="d-inline-block me-1">
                                  {" و "}
                                  <span className="d-inline-block" key={xn}>
                                    {extra_number}
                                  </span>
                                </span>
                              )
                            )}
                            :
                          </span>
                        </div>
                        <span className="col mb-0 small px-0 align-self-center text-start">
                          {moneyFormat(price.price, null, "fw-bolder")}
                        </span>
                      </div>
                    </div>
                  ))}
                  <div className="col-12 text-center fs-7">
                    به تمامی قیمت ها 10% ارزش افزوده اضافه میشود.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="text-center py-3 mt-5">
          <Spinner
            size="md"
            className="align-middle text-main"
            animation="border"
          />
        </div>
      )}
    </div>
  );
}
